const WorkflowStatusDonutChart = (data = []) => {
  const total = data.reduce((sum, item) => sum + item.count, 0);

  const processedData = data.map(item => ({
    name: item.label,
    value: item.count,
    itemStyle: {
      color: item.color || '#ccc'
    }
  }));

  return {
    animationDuration: 1000,
    animationEasing: 'cubicOut',
    tooltip: {
      trigger: 'item',
      formatter: ({ name, value, percent }) => {
        return `
          <div style="font-weight: bold; margin-bottom: 4px;">${name}</div>
          <div>Tasks: ${value}<br/>Share: ${percent}%</div>
        `;
      }
    },
    legend: {
      show: false
    },
    graphic: {
      type: 'group',
      left: 'center',
      top: 'center',
      children: [
        {
          type: 'text',
          style: {
            text: 'Total',
            fontSize: 14,
            fill: '#666',
            textAlign: 'center'
          },
          top: -12,
          left: 0
        },
        {
          type: 'text',
          style: {
            text: total.toString(),
            fontSize: 28,
            fontWeight: 'bold',
            fill: '#000',
            textAlign: 'center'
          },
          top: 8,
          left: 8
        }
      ]
    },
    series: [
      {
        name: 'Workflow Status',
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          position: 'outside',
          formatter: '{b}: {d}%',
          fontSize: 13
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10
        },
        data: processedData
      }
    ]
  };
};

export default WorkflowStatusDonutChart;
